import { Game } from '../../../gql-types';
import Button from '../buttons/Button';
import GameStatusBadge from './GameStatusBadge';
import del from '../../../assets/icons/delete.svg';
import edit from '../../../assets/icons/edit.svg';

type Props = {
    items: Game[];
    loading: boolean;
    pageSize: number;
    onEdit: (g: Game) => void;
    onDelete: (g: Game) => void;
    onCopyCode: (code: string) => void;
    gameTypeLabel: Record<string, string>;
};

function formatUnixDate(unix: string | null | undefined): string {
    if (!unix) return '—';
    const n = parseInt(unix, 10);
    if (!Number.isFinite(n)) return '—';
    return new Date(n * 1000).toLocaleDateString('cs-CZ');
}

export default function AdminGamesTable({
    items,
    loading,
    pageSize,
    onEdit,
    onDelete,
    onCopyCode,
    gameTypeLabel,
}: Props) {
    const showSkeleton = loading && items.length === 0;
    return (
        <div className="admin-table-scroll">
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Stav</th>
                        <th>Kód</th>
                        <th>Typ</th>
                        <th>Email</th>
                        <th>Tým</th>
                        <th>Platnost do</th>
                        <th>Celkový čas</th>
                        <th aria-label="Akce" />
                    </tr>
                </thead>
                <tbody>
                    {showSkeleton &&
                        Array.from({ length: pageSize }).map((_, i) => (
                            <tr key={`s-${i}`} className="skeleton-row">
                                {Array.from({ length: 8 }).map((__, j) => (
                                    <td key={j}>
                                        <span className="skeleton-bar" />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    {!showSkeleton && items.length === 0 && (
                        <tr>
                            <td colSpan={8} className="admin-table__empty">
                                Žádné hry neodpovídají filtrům.
                            </td>
                        </tr>
                    )}
                    {!showSkeleton &&
                        items.map((g) => (
                            <tr key={g._id ?? g.code ?? Math.random()}>
                                <td>
                                    <GameStatusBadge used={g.used} validFrom={g.validFrom} validTo={g.validTo} />
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        className="code-copy"
                                        title="Kopírovat kód"
                                        onClick={() => g.code && onCopyCode(g.code)}
                                    >
                                        {g.code ?? '—'}
                                    </button>
                                </td>
                                <td>{g.gameType ? gameTypeLabel[g.gameType] ?? g.gameType : '—'}</td>
                                <td className="truncate">{g.email ?? '—'}</td>
                                <td className="truncate">{g.teamName ?? '—'}</td>
                                <td>{formatUnixDate(g.validTo)}</td>
                                <td>{g.finalTime ?? '—'}</td>
                                <td>
                                    <div className="table-buttons">
                                        <Button className="secondary-button" onClick={() => onEdit(g)}>
                                            <img src={edit} alt="Upravit" width={20} />
                                        </Button>
                                        <Button className="secondary-button" onClick={() => onDelete(g)}>
                                            <img src={del} alt="Smazat" width={20} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
}
